<template>
  <a-table :columns="columns" :data-source="driverPage.records">
    <template #operation>
      <a-space>
        <a-button type="link">编辑</a-button>
      </a-space>
    </template>
  </a-table>
</template>

<script>
export default {
  name: 'DriverTable',
  props: {
    driverPage: {
      type: Object,
      default: () => {
        return {
          records: []
        }
      }
    }
  },
  data () {
    const columns = [
      {
        title: '驱动名称',
        dataIndex: 'driverName',
        key: 'driverName'
      },
      {
        title: '协议类型',
        dataIndex: 'protocolType',
        key: 'protocolType'
      },
      {
        title: '实例数',
        dataIndex: 'ipCount',
        key: 'ipCount'
      },
      {
        title: '健康实例数',
        dataIndex: 'healthyInstanceCount',
        key: 'healthyInstanceCount'
      },
      {
        title: '操作',
        dataIndex: 'operation',
        key: 'operation'
      }
    ]
    return {
      columns
    }
  },
  watch: {
    driverPage: {
      handler (val, oldVal) {
        console.log(val, oldVal)
      },
      immediate: true,
      deep: true
    }
  }
}
</script>

<style scoped>

</style>
